import Icon from "@ant-design/icons";

const PayrollSearchIconSVG = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1665 18.9584H5.83317C2.9665 18.9584 1.0415 17.0334 1.0415 14.1667V10C1.0415 7.43337 2.62484 5.57505 5.08317 5.26671C5.3165 5.23338 5.57484 5.20837 5.83317 5.20837H14.1665C14.3665 5.20837 14.6248 5.21671 14.8915 5.25837C17.3498 5.54171 18.9582 7.40837 18.9582 10V14.1667C18.9582 17.0334 17.0332 18.9584 14.1665 18.9584ZM5.83317 6.45837C5.63317 6.45837 5.4415 6.47503 5.24984 6.50003C3.4165 6.73336 2.2915 8.06671 2.2915 10V14.1667C2.2915 16.3167 3.68317 17.7084 5.83317 17.7084H14.1665C16.3165 17.7084 17.7082 16.3167 17.7082 14.1667V10C17.7082 8.05004 16.5665 6.70838 14.7165 6.49171C14.5165 6.45838 14.3415 6.45837 14.1665 6.45837H5.83317Z"
      fill="url(#paint0_linear_717_8113)"
    />
    <path
      d="M5.15854 6.50841C4.95854 6.50841 4.7752 6.41675 4.6502 6.25008C4.50854 6.05841 4.49187 5.80842 4.6002 5.60008C4.74187 5.31675 4.94187 5.04175 5.2002 4.79175L7.90853 2.07507C9.29187 0.700073 11.5419 0.700073 12.9252 2.07507L14.3835 3.55009C15.0002 4.15842 15.3752 4.97509 15.4169 5.84176C15.4252 6.03342 15.3502 6.21674 15.2085 6.34174C15.0669 6.46674 14.8752 6.52509 14.6919 6.49176C14.5252 6.46676 14.3502 6.45841 14.1669 6.45841H5.83354C5.63354 6.45841 5.44187 6.47507 5.2502 6.50007C5.2252 6.5084 5.19187 6.50841 5.15854 6.50841ZM6.5502 5.20841H14.0169C13.9085 4.92508 13.7335 4.66675 13.5002 4.43342L12.0335 2.95009C11.1419 2.06676 9.68354 2.06676 8.78354 2.95009L6.5502 5.20841Z"
      fill="url(#paint1_linear_717_8113)"
    />
    <path
      d="M18.3337 14.3751H15.8337C14.567 14.3751 13.542 13.3501 13.542 12.0834C13.542 10.8167 14.567 9.79175 15.8337 9.79175H18.3337C18.6753 9.79175 18.9587 10.0751 18.9587 10.4167C18.9587 10.7584 18.6753 11.0417 18.3337 11.0417H15.8337C15.2587 11.0417 14.792 11.5084 14.792 12.0834C14.792 12.6584 15.2587 13.1251 15.8337 13.1251H18.3337C18.6753 13.1251 18.9587 13.4084 18.9587 13.7501C18.9587 14.0917 18.6753 14.3751 18.3337 14.3751Z"
      fill="url(#paint2_linear_717_8113)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_717_8113"
        x1="1.0415"
        y1="12.0834"
        x2="18.9582"
        y2="12.0834"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_717_8113"
        x1="4.52979"
        y1="3.77612"
        x2="15.4175"
        y2="3.77612"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_717_8113"
        x1="13.542"
        y1="12.0834"
        x2="18.9587"
        y2="12.0834"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
    </defs>
  </svg>
);
const PayrollSearchIcon = (props) => (
  <Icon component={() => PayrollSearchIconSVG(props)} {...props} />
);

export default PayrollSearchIcon;
